export class RegionReferenceModel {
    public regionCode: string;
    public regionName: string; 
    public statusCode: string;    
}
